import type { LeaderboardFilters, QuickFilterId } from "../types/filters.ts";
import { matchQuickFilter, QUICK_FILTER_IDS, QUICK_FILTER_PRESETS } from "../types/filters.ts";

interface Props {
  filters: LeaderboardFilters;
  onApplyPreset: (id: QuickFilterId) => void;
  onClearPreset: (id: QuickFilterId) => void;
}

export function LeaderboardQuickFilters({ filters, onApplyPreset, onClearPreset }: Props) {
  const activePresetId = QUICK_FILTER_IDS.find((id) =>
    matchQuickFilter(filters, QUICK_FILTER_PRESETS[id])
  );

  return (
    <div className="leaderboard-quickfilters" role="toolbar" aria-label="Quick filters">
      {QUICK_FILTER_IDS.map((id) => {
        const preset = QUICK_FILTER_PRESETS[id];
        const isActive = activePresetId === id;
        return (
          <button
            key={id}
            type="button"
            className={`leaderboard-quickfilter-chip${isActive ? " is-active" : ""}`}
            title={preset.hint}
            // Clicking an active chip clears just the preset's keys
            // (so the search box and any unrelated filters are
            // preserved). Reset-All is reachable via the active-filter
            // summary row.
            onClick={() => (isActive ? onClearPreset(id) : onApplyPreset(id))}
          >
            {preset.label}
          </button>
        );
      })}
    </div>
  );
}
